import { useCallback, useState } from 'react';
import type { CreativeEngineTab } from './CreativeEngine.types';
import { CREATIVE_ENGINE_TABS } from './CreativeEngine.types';
import CreativeEngineView from './CreativeEngine.View';

const CreativeEngineContainer = () => {
  const [activeTab, setActiveTab] = useState<CreativeEngineTab>(
    CREATIVE_ENGINE_TABS.CreativeBriefs
  );
  // A panel mounts the first time its tab is opened and stays mounted afterwards,
  // so switching tabs never discards unsaved edits, but an unopened tab pays no
  // load cost. The default tab is activated up front.
  const [activatedTabs, setActivatedTabs] = useState<Set<CreativeEngineTab>>(
    () => new Set([CREATIVE_ENGINE_TABS.CreativeBriefs])
  );

  const handleTabChange = useCallback((tab: CreativeEngineTab) => {
    setActiveTab(tab);
    setActivatedTabs(prev => (prev.has(tab) ? prev : new Set(prev).add(tab)));
  }, []);

  return (
    <CreativeEngineView
      activeTab={activeTab}
      activatedTabs={activatedTabs}
      onTabChange={handleTabChange}
    />
  );
};

export default CreativeEngineContainer;
